

import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import { InputCheckBox } from '../../dashboard/subContent/CheckBox/InputCheckBox'
import useSearchMember from '../../../hooks/fetchUsers'
import { OutboxDataTable } from './OutboxDataTable'
import { outboxesStateModel } from './OutboxesStateModel'
import { outboxSearchSchema } from './outboxSearchSchema'
import { useEffect } from 'react'


export const Outbox = () => {

useEffect(() => {
    document.title = 'TPA® Admin - Emails'
  }, [])

  const URL = 'Outbox'

  const { renderUsers, handleObject, loading,customData } = useSearchMember(URL)

  return (
    <>
     
      <SearchContainer 
      handleObject={handleObject}
      searchSchema={outboxSearchSchema}
      selectListOptions={[]}
      />

      <InputCheckBox 
      handleObject={handleObject}
      />

      <OutboxDataTable
      stateModel={outboxesStateModel}
       currentPagination={customData.current}
        usersData={renderUsers}
        handleObject={handleObject}
        loading={loading}
        memberShip={false} //👉 activa el modal de informacion del miembro
        alert={false} //👉 activa el modal de alerta de acciones 
      />

    </>
  )
}



